<script>
export default {
  name: 'FileWrapper',
  inheritAttrs: false,
  props: {
    transitionProps: {
      type: Object,
      default: () => { return {} }
    }
  },
  render (createElement) {
    return createElement('transition',
      {
        props: this.transitionProps
      },
      [
        createElement('keep-alive', this.$slots.default)
      ])
  }
}
</script>
